const COVER_YUANQI = require('@/assets/facade/01.jpg')
const COVER_BAOJIAN = require('@/assets/facade/02.jpg')
const COVER_JINGYOU = require('@/assets/facade/03.jpg')
const COVER_CHANHOU = require('@/assets/facade/04.jpg')
const COVER_TITAI = require('@/assets/facade/05.jpg')
const COVER_JUBU = require('@/assets/facade/06.jpg')

/** 表 status：on_sale / off_shelf */
export const TUINA_PROJECT_STATUS_OPTIONS = [
  { id: 'on_sale', value: '上架' },
  { id: 'off_shelf', value: '下架' }
]

export const TUINA_PROJECTS = [
  {
    id: 'p1',
    storeId: 0,
    code: 'yuanqi_heat',
    name: '元气推拿+热敷',
    durationMinutes: 60,
    price: 298,
    timesCount: 1,
    coverUrl: COVER_YUANQI,
    description: '全身推拿配合热敷，疏通经络、缓解疲劳，适合日常保养。',
    status: 'on_sale',
    sortOrder: 1
  },
  {
    id: 'p2',
    storeId: 0,
    code: 'baojian',
    name: '保健推拿',
    durationMinutes: 60,
    price: 128,
    timesCount: 1,
    coverUrl: COVER_BAOJIAN,
    description: '基础保健手法，放松肩颈腰背，适合久坐人群。',
    status: 'on_sale',
    sortOrder: 2
  },
  {
    id: 'p3',
    storeId: 0,
    code: 'jingyou',
    name: '精油推拿',
    durationMinutes: 60,
    price: 199,
    timesCount: 1,
    coverUrl: COVER_JINGYOU,
    description: '精油开背与全身推拿，舒缓紧张，改善睡眠。',
    status: 'on_sale',
    sortOrder: 3
  },
  {
    id: 'p4',
    storeId: 0,
    code: 'chanhou_heat',
    name: '产后调理+热敷',
    durationMinutes: 80,
    price: 588,
    timesCount: 1,
    coverUrl: COVER_CHANHOU,
    description: '针对产后体质的手法与热敷，帮助恢复体态与气血。',
    status: 'on_sale',
    sortOrder: 4
  },
  {
    id: 'p5',
    storeId: 0,
    code: 'titai_heat',
    name: '体型体态调理+热敷',
    durationMinutes: 80,
    price: 468,
    timesCount: 1,
    coverUrl: COVER_TITAI,
    description: '针对肩颈、骨盆与体态的深层调理，配合热敷放松筋膜。',
    status: 'on_sale',
    sortOrder: 5
  },
  {
    id: 'p6',
    storeId: 0,
    code: 'jubu_heat',
    name: '局部推拿+热敷',
    durationMinutes: 50,
    price: 88,
    timesCount: 1,
    coverUrl: COVER_JUBU,
    description: '针对肩、腰或腿等单一部位的短时推拿与热敷。',
    status: 'off_shelf',
    sortOrder: 6
  }
]
